<template>

  <ChartNormal
  size="12"
  offset="0"
  title="Active Backlog"
  chart="column"
  chartType="backlog"
  :isCity="false"
  :withDate="false"
  :withFinancial="false" />

</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "ActiveBacklog",
  components: {
    ChartNormal,
  }
};
</script>
